import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "image"]

  open(e) {
    e.preventDefault()

    this.images = JSON.parse(e.currentTarget.dataset.images)
    this.index = +e.currentTarget.dataset.index

    this.render()

    this.modalTarget.classList.add("open")

    this.keydown ||= this.handle.bind(this)

    window.addEventListener("keydown", this.keydown)

    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.remove("open")

    window.removeEventListener("keydown", this.keydown)

    document.body.classList.remove("overflow-hidden")
  }

  next(e) {
    e?.stopPropagation()

    this.index = (this.index + 1) % this.images.length

    this.render()
  }

  prev(e) {
    e?.stopPropagation()

    this.index =
      (this.index - 1 + this.images.length) % this.images.length

    this.render()
  }

  background(e) {
    // cerrar solo si clickea fuera de la imagen
    if (e.target === this.modalTarget) {
      this.close()
    }
  }

  render() {
    this.imageTarget.src = this.images[this.index]
  }

  handle(e) {
    if (e.key === "Escape") this.close()

    if (e.key === "ArrowRight") this.next()

    if (e.key === "ArrowLeft") this.prev()
  }
}